// src/lib/schema/index.js

// Import base schema generators
import {
  generateProductSchema,
  createProductSchemaString
} from './base/product';

import {
  generateOrganizationSchema
} from './base/organization';

import {
  generateWebsiteSchema
} from './base/website';

import {
  generateBreadcrumbSchema,
  generateEcommerceBreadcrumbSchema
} from './base/breadcrumb';

import {
  generateCollectionSchema,
  generateFilteredCollectionSchema
} from './base/collection';

import {
  generateFAQSchema,
  generateProductFAQSchema,
  generateShippingFAQSchema
} from './base/faq';

import {
  generateLocalBusinessSchema,
  generateMultipleStoresSchema
} from './base/localBusiness';

// Import helpers
import {
  getValidUntilDate,
  formatISODate,
  getLastModifiedDate,
  formatSchemaDate,
  getPriceValidityDate
} from './helpers/dateHelpers';

import {
  validateRequiredFields,
  isValidUrl,
  isValidSchema,
  isValidPrice,
  isValidCurrency,
  isValidImage
} from './validators';

import {
  extractMetadata,
  createMetadataObject,
  normalizeProductData
} from './helpers/metadataHelpers';

import {
  schemaToString,
  combineSchemasToGraph,
  combineSchemasToString,
  formatPrice,
  formatAvailability,
  formatTitle,
  buildUrl,
  cleanObject
} from './helpers/formatters';

// Import React components
import { ProductSchema } from './components/ProductSchema';
import { WebsiteSchema } from './components/WebsiteSchema';
import {
  CollectionSchema,
  FilteredCollectionSchema
} from './components/CollectionSchema';
import {
  FAQSchema,
  ProductFAQSchema,
  ShippingFAQSchema
} from './components/FAQSchema';
import { OrganizationSchema } from './components/OrganizationSchema';
import {
  LocalBusinessSchema,
  MultipleStoresSchema
} from './components/LocalBusinessSchema';
import {
  BreadcrumbSchema,
  EcommerceBreadcrumbSchema
} from './components/BreadcrumbSchema';

// Export base schema generators
export {
  generateProductSchema,
  createProductSchemaString,
  generateOrganizationSchema,
  generateWebsiteSchema,
  generateBreadcrumbSchema,
  generateEcommerceBreadcrumbSchema,
  generateCollectionSchema,
  generateFilteredCollectionSchema,
  generateFAQSchema,
  generateProductFAQSchema,
  generateShippingFAQSchema,
  generateLocalBusinessSchema,
  generateMultipleStoresSchema
};

// Export helper functions
export {
  // Date helpers
  getValidUntilDate,
  formatISODate,
  getLastModifiedDate,
  formatSchemaDate,
  getPriceValidityDate,

  // Validators
  validateRequiredFields,
  isValidUrl,
  isValidSchema,
  isValidPrice,
  isValidCurrency,
  isValidImage,

  // Metadata helpers
  extractMetadata,
  createMetadataObject,
  normalizeProductData,

  // Formatters
  schemaToString,
  combineSchemasToGraph,
  combineSchemasToString,
  formatPrice,
  formatAvailability,
  formatTitle,
  buildUrl,
  cleanObject
};

// Export React components
export {
  ProductSchema,
  WebsiteSchema,
  CollectionSchema,
  FilteredCollectionSchema,
  FAQSchema,
  ProductFAQSchema,
  ShippingFAQSchema,
  OrganizationSchema,
  LocalBusinessSchema,
  MultipleStoresSchema,
  BreadcrumbSchema,
  EcommerceBreadcrumbSchema
};
